import * as React from "react";

import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {FieldItemBase, FieldItemBaseProps, FieldItemBaseState} from "InternalShared/PageBuilder/Fields/FieldItemBase";


export class LinkFieldItem extends FieldItemBase<TextFieldItemProps, TextFieldItemState> {
    static defaultProps: Partial<TextFieldItemProps> = {};

    constructor(props: TextFieldItemProps) {
        super(props);
        this.state = {

        };
    }

    protected GetImage() {
        return 'link.png'
    }

    protected GetText() {
        return 'Link'
    }

    protected GetType() {
        return ControlTypeEnum.Link;
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TextFieldItemProps extends FieldItemBaseProps{

}

interface TextFieldItemState extends FieldItemBaseState{

}

//#endregion "My Region"